<!-- <app-inventory [borrowingView]="borrowingView" [borrowingStore]="borrowingStore"></app-inventory> -->
<app-inventory></app-inventory>